/* eslint-disable react/function-component-definition */
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "config/api";
import MDBox from "components/MDBox";
import CircularProgress from "@mui/material/CircularProgress";

/**
 * Üyelik default landing decider.
 * If the user has any ACTIVE arıza (teknik hizmet talebi), land on /uyelik/arizalarim.
 * Otherwise fall back to the listings page (/uyelik/ilan).
 */
function UyelikHome() {
  const [target, setTarget] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const decide = async () => {
      // Honor a pending Teknik Hizmet intent set before signup/login
      const pendingRedirect = localStorage.getItem("postLoginRedirect");
      if (pendingRedirect) {
        localStorage.removeItem("postLoginRedirect");
        sessionStorage.removeItem("postLoginRedirect");
        if (!cancelled) setTarget(pendingRedirect);
        return;
      }
      try {
        const res = await axios.get(`${API_BASE_URL}/ariza`, {
          params: { role_scope: "uyelik", active_only: true },
        });
        const hasActive = Array.isArray(res.data) && res.data.length > 0;
        if (!cancelled) setTarget(hasActive ? "/uyelik/arizalarim" : "/uyelik/ilan");
      } catch (e) {
        if (!cancelled) setTarget("/uyelik/ilan");
      }
    };
    decide();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!target) {
    return (
      <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress color="info" />
      </MDBox>
    );
  }

  return <Navigate to={target} replace />;
}

export default UyelikHome;
